




































import { defineComponent } from '@vue/composition-api';
import { ArrowsExpandIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'ExpandCollapseIcon',
    components: {
        ArrowsExpandIcon,
    },
    props: {
        isExpanded: {
            type: Boolean,
            required: true,
        },
        colour: {
            type: String,
            default: 'text-neutral-700',
        },
    },
});
